// client/src/components/VariableEditor.jsx
import { theme } from '../theme';
import { inputStyle } from './templateStyles';
import { useIsMobile } from '../hooks/useMediaQuery';

// vars: string[] nombres detectados | variants: { [name]: {type,value/field} }
// customFields: [{id,name}] | onChange: (nextVariants) => void
function VariableEditor({ vars, variants, customFields, onChange, idPrefix = 'var' }) {
  const isMobile = useIsMobile();
  if (vars.length === 0) return null;

  const set = (name, next) => onChange({ ...variants, [name]: next });

  return (
    <div style={{ marginTop: '1rem' }}>
      <p style={{ color: theme.colors.textMuted, fontSize: '0.8rem', marginBottom: '0.5rem' }}>
        Variables detectadas:
      </p>
      {vars.map((name) => {
        const v = variants[name];
        const isFixed = !v || v.type === 'fixed';
        return (
          <div key={name} style={{
            display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.6rem 0.8rem',
            backgroundColor: theme.colors.surface, borderRadius: '7px', marginBottom: '0.5rem', flexWrap: 'wrap',
          }}>
            <code style={{ color: theme.colors.primary, fontSize: '0.85rem', flexShrink: 0 }}>{`{{${name}}}`}</code>
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.3rem', cursor: 'pointer' }}>
              <input type="radio" name={`${idPrefix}-${name}`} checked={isFixed}
                onChange={() => set(name, { type: 'fixed', value: v?.value || '' })}
                style={{ accentColor: theme.colors.primary }} />
              <span style={{ color: theme.colors.text, fontSize: '0.85rem' }}>Texto fijo</span>
            </label>
            {isFixed && (
              <input type="text" value={v?.value || ''}
                onChange={(e) => set(name, { type: 'fixed', value: e.target.value })}
                placeholder="Valor fijo..." style={{ ...inputStyle, width: isMobile ? '100%' : '150px', padding: '5px 8px' }} />
            )}
            <label style={{ display: 'flex', alignItems: 'center', gap: '0.3rem', cursor: 'pointer' }}>
              <input type="radio" name={`${idPrefix}-${name}`} checked={v?.type === 'field'}
                onChange={() => set(name, { type: 'field', field: v?.field || '' })}
                style={{ accentColor: theme.colors.primary }} />
              <span style={{ color: theme.colors.text, fontSize: '0.85rem' }}>Texto variable</span>
            </label>
            {v?.type === 'field' && (
              <select value={v?.field || ''}
                onChange={(e) => set(name, { type: 'field', field: e.target.value })}
                style={{ ...inputStyle, width: isMobile ? '100%' : '180px', padding: '5px 8px', cursor: 'pointer' }}>
                <option value="">— Seleccionar campo —</option>
                {customFields.map((cf) => <option key={cf.id} value={cf.name}>{cf.name}</option>)}
              </select>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default VariableEditor;
